import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const hangarPlugin = createPlugin({
  id: 'hangar',
  routes: {
    root: rootRouteRef,
  },
});

export const HangarPage = hangarPlugin.provide(
  createRoutableExtension({
    name: 'HangarPlugin',
    component: () => import('./components/HomePage').then(m => m.HomePage),
    mountPoint: rootRouteRef,
  }),
);
